import { DASHBOARD_WORKBOARD_SLUG } from 'dashboard409a/common/constants';

// Key for storing the previous workboard route in localStorage
const WORKBOARD_PREVIOUS_ROUTE_KEY = 'workboard_previous_route';

/**
 * Gets the previously saved workboard route from localStorage
 * @returns The saved route or null if none exists
 */
export const getPreviousWorkboardRoute = (): string | null => {
  if (globalThis.window) {
    return globalThis.window.localStorage.getItem(WORKBOARD_PREVIOUS_ROUTE_KEY);
  }
  return null;
};

/**
 * Clears the previously saved workboard route from localStorage
 */
export const clearPreviousWorkboardRoute = (): void => {
  if (globalThis.window) {
    globalThis.window.localStorage.removeItem(WORKBOARD_PREVIOUS_ROUTE_KEY);
  }
};

/**
 * Saves the current workboard route to localStorage
 * @param route - The workboard route to save
 */
export const savePreviousWorkboardRoute = (route: string): void => {
  if (globalThis.window && route.includes(DASHBOARD_WORKBOARD_SLUG)) {
    globalThis.window.localStorage.setItem(WORKBOARD_PREVIOUS_ROUTE_KEY, route);
  }
};

